import axios from "axios";

const API_BASE = process.env.REACT_APP_API_URL;

/**
 * Demande/Crée un code de parrainage côté backend.
 * Retourne le code de parrainage (string).
 */
export async function requestReferralCode({ accessToken, username, signal }) {
  if (!API_BASE) throw new Error("REACT_APP_API_URL est manquant.");
  if (!accessToken) throw new Error("Token d'accès manquant.");
  if (!username) throw new Error("Username manquant.");

  const url = `${API_BASE}/stripe-request-referral-code`;

  const resp = await axios.post(
    url,
    { username },
    {
      headers: {
        Authorization: `Bearer ${accessToken}`,
        "Content-Type": "application/json",
      },
      signal, // optionnel: AbortController si tu veux annuler
      validateStatus: () => true, // on gère nous-mêmes les erreurs
    }
  );

  // Accepte 200 / 201
  if (resp.status !== 200 && resp.status !== 201) {
    const apiErr = resp?.data?.error || resp?.data?.message || `Erreur HTTP ${resp.status}`;
    throw new Error(apiErr);
  }

  // Supporte { referral_code } ou { code }
  const code = resp?.data?.referral_code || resp?.data?.code;
  if (!code) throw new Error("Code de parrainage introuvable dans la réponse.");

  return code; // <-- on garde le contrat: retourne une string
}
